import { render } from "./edit.vue?vue&type=template&id=3f43b9a6"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customers/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f43b9a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f43b9a6', __exports__)) {
    console.log('reload')
    api.reload('3f43b9a6', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=3f43b9a6", () => {
    console.log('re-render')
    api.rerender('3f43b9a6', render)
  })

}


export default __exports__